__webpack_require__.p = "https://dev2.glprotocol.com/";